/* so-live-prices.js — SocialOrange, 10 Oct 2026.
   Product cards and PDP offer notes are baked into static snippets at build time, so their prices go stale
   whenever Shopify prices change (e.g. Amit's EAN-level offer sheet). This repaints every card price box,
   sale / size-S badge and the PDP size-S offer note from the live /products.json. Cached 5 min per tab. */
(function () {
  'use strict';
  var KEY = 'so_lp_v1', TTL = 5 * 60 * 1000;
  var isS = function (v) { return [v.option1, v.option2, v.option3].some(function (o) { return o && String(o).trim().toUpperCase() === 'S'; }); };
  var money = function (n) { return '₹ ' + Number(n).toFixed(2); };
  var pctOff = function (p, c) { return c > p ? Math.round((1 - p / c) * 100) : 0; };

  function load() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && Date.now() - c.t < TTL) return Promise.resolve(c.m);
    } catch (e) {}
    var map = {};
    function page(n) {
      return fetch('/products.json?limit=250&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        (j.products || []).forEach(function (p) {
          map[p.handle] = p.variants.map(function (v) {
            return [parseFloat(v.price), parseFloat(v.compare_at_price || 0), isS(v) ? 1 : 0, v.available ? 1 : 0];
          });
        });
        return (j.products || []).length === 250 && n < 8 ? page(n + 1) : map;
      });
    }
    return page(1).then(function (m) {
      try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), m: m })); } catch (e) {}
      return m;
    });
  }

  // vs: [[price, compareAt, isS, available], ...]
  function summarise(vs) {
    var pool = vs.filter(function (v) { return v[3]; });
    if (!pool.length) pool = vs;
    var prices = pool.map(function (v) { return v[0]; });
    var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
    var disc = pool.filter(function (v) { return v[1] > v[0]; });
    var nonS = pool.filter(function (v) { return !v[2]; });
    var sDisc = pool.filter(function (v) { return v[2] && v[1] > v[0]; });
    var allDisc = disc.length === pool.length && pool.length > 0;
    var cheapest = pool.filter(function (v) { return v[0] === min; })[0];
    var pcts = disc.map(function (v) { return pctOff(v[0], v[1]); });
    return {
      min: min, max: max, allDisc: allDisc, cmp: allDisc ? cheapest[1] : 0,
      maxPct: pcts.length ? Math.max.apply(null, pcts) : 0,
      sPct: sDisc.length ? Math.max.apply(null, sDisc.map(function (v) { return pctOff(v[0], v[1]); })) : 0,
      sOnly: sDisc.length > 0 && !nonS.some(function (v) { return v[1] > v[0]; })
    };
  }

  function badge(inner, cls, text) {
    var b = document.createElement('span');
    b.className = 't4s-badge-sale t4s-pa ' + cls;
    b.textContent = text;
    var here = inner.querySelector('[class*="t4s-badge-"]');
    var host = here && here.parentElement;
    if (!host) {
      var tpl = document.querySelector('.t4s-product [class*="t4s-badge-"]');
      var tw = tpl && tpl.parentElement;
      if (tw && !tw.classList.contains('t4s-product-inner')) {
        host = document.createElement('div'); host.className = tw.className; inner.appendChild(host);
      } else host = inner;
    }
    style(b);
    host.appendChild(b);
    return b;
  }
  function setText(el, t) { if (el.textContent !== t) el.textContent = t; }
  // monochrome brand: every offer badge is black, same box as the baked ones
  var BADGE = 'top:10px;right:10px;background:#111;color:#fff;font-size:10px;font-weight:700;padding:2px 8px;border-radius:2px;z-index:3;letter-spacing:.02em;';
  function style(el) { if (el.getAttribute('style') !== BADGE) el.setAttribute('style', BADGE); }

  function paintCard(card, map) {
    var a = card.querySelector('a[href*="/products/"]');
    var box = card.querySelector('.so-card-price-box');
    if (!a || !box) return;
    var h = a.getAttribute('href').split('/products/')[1];
    if (!h) return;
    h = decodeURIComponent(h.split(/[?#/]/)[0]);
    var vs = map[h] || (Object.keys(map).length > 50 ? [] : null); // a thin/failed catalogue never hides cards
    if (!vs) return;
    // Sold out everywhere, or not on the store at all (drafted by inventory/oos_visibility_sync.py) -> hide the card (28 Oct: Neeraj, zero-stock products must not be visible).
    // Cards are baked at build time, so the baked "Sold out" badge is stale either way: drop it when live stock exists.
    var inStock = vs.some(function (v) { return v[3]; });
    if (card.classList.contains('so-oos') === inStock) { card.classList.toggle('so-oos', !inStock); paintCard.changed = true; }
    if (inStock) [].forEach.call(card.querySelectorAll('.t4s-badge-soldout'), function (b) { b.remove(); });
    if (!vs.length) return;
    var s = summarise(vs);
    var txt = s.min === s.max ? money(s.min) : money(s.min) + ' – ' + money(s.max);
    var html = (s.allDisc ? '<del class="t4s-price__compare">' + money(s.cmp) + '</del> ' : '') + '<span class="so-card-price">' + txt + '</span>';
    if (box.getAttribute('data-so-lp') !== html) { box.innerHTML = html; box.setAttribute('data-so-lp', html); }

    var inner = card.querySelector('.t4s-product-inner') || card;
    var sale = [].filter.call(inner.querySelectorAll('.t4s-badge-sale'), function (b) { return !b.classList.contains('so-badge-soffer'); });
    var soff = inner.querySelector('.so-badge-soffer');
    if (s.allDisc) {
      if (soff) soff.remove();
      var label = s.maxPct + '% off';
      if (sale.length) { setText(sale[0], label); style(sale[0]); sale.slice(1).forEach(function (b) { b.remove(); }); }
      else badge(inner, 'so-badge-live', label);
    } else if (s.sOnly) {
      sale.forEach(function (b) { b.remove(); });
      if (soff) { setText(soff, 'Size S ' + s.sPct + '% off'); style(soff); }
      else badge(inner, 'so-badge-soffer', 'Size S ' + s.sPct + '% off');
    } else {
      sale.forEach(function (b) { b.remove(); });
      if (soff) soff.remove();
    }
  }

  function paintPDP(map) {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    var box = document.querySelector('.so-offerbox');
    if (!m || !box) return;
    var vs = map[decodeURIComponent(m[1])];
    if (!vs) return;
    var s = summarise(vs);
    if (s.allDisc || !s.sPct) { if (box.style.display !== 'none') box.style.display = 'none'; return; }
    var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
    for (var n; (n = walker.nextNode());) {
      if (/\d+\s*%\s*off/i.test(n.nodeValue) && n.nodeValue.indexOf(s.sPct + '% off') < 0) n.nodeValue = n.nodeValue.replace(/\d+\s*%\s*off/i, s.sPct + '% off');
    }
  }


  // Bag offer (13 Oct 2026, live for everyone): Amit's slab on these 71 styles, applied automatically in the bag.
  // Mirrors the Shopify automatic discounts "Bag offer: shop for ₹X get Y% off" (pricing/golive_2026-10-13).
  var BAG = window.SO_BAG_OFFER = { live: true, tiers: [[2999, 20], [4999, 25], [6999, 30], [9999, 50]], handles: ["fc-moisture-wicking-antimicrobial-cotton-modal-baron-mens-long-trunk-pack-of-2", "fc-moisture-wicking-antimicrobial-cotton-modal-oxford-mens-long-trunk-pack-of-2", "fcuk-flex-berskhire-mens-oversized-hooded-sweatshirt", "fcuk-flex-holborn-mens-shorts", "fcuk-moisture-wicking-antimicrobial-cotton-baton-mens-vests-pack-of-3", "fcuk-moisture-wicking-antimicrobial-cotton-rove-mens-vests-pack-of-2", "fcuk-moisture-wicking-cotton-poly-viscose-heat-retention-bradfordmens-thermals-t-shirts", "fcuk-moisture-wicking-heat-retention-bradford-lj-mens-thermals-long-john", "fcuk-play-leyton-mens-boxers", "fcuk-play-leyton-mens-printed-boxer", "french-connection-charlton-mens-loungepants-pack-of-1", "french-connection-charron-mens-jog-pants", "french-connection-durance-mens-hooded-sweatshirt", "french-connection-leers-mens-crew-neck-sweatshirt", "french-connection-lyon-mens-loungepants-pack-of-1", "french-connection-rhone-mens-high-neck-sweatshirt", "french-connection-siene-mens-lounge-pants", "heritage-striped-unisex-short-crew-socks-pack-of-3", "puma-bamboo-mens-printed-trunk-gray-violet-white-black", "puma-bamboo-mens-printed-trunk-team-royal-vibrant-oragne-white", "puma-bamboo-mens-trunks-black-white", "puma-bamboo-mens-trunks-deep-teal-black", "puma-bamboo-mens-trunks-vineyard-wine-black", "puma-bamboo-mens-trunks-warm-chestnut-white", "puma-basic-sleeveless-mens-vests-pack-of-2-with-everfresh-technology", "puma-basic-sleeveless-mens-vests-pack-of-2-with-everfresh-technology-1", "puma-mens-basic-cotton-woven-boxers-pack-of-1", "puma-mens-basic-woven-boxers", "puma-mens-crew-neck-vests-pack-of-2-with-everfresh-technology", "puma-mens-lounge-pants-black", "puma-mens-lounge-pants-navy", "puma-mens-lounge-pants-olive", "puma-mens-lounge-pants-warm-chestnut-black", "puma-mens-printed-lounge-pants-black-mint-white", "puma-mens-printed-lounge-pants-black-red", "puma-mens-printed-lounge-pants-black-white", "puma-mens-sleeveless-vests-pack-of-2-with-everfresh-technology", "puma-supima-mens-trunks-asphalt", "puma-supima-mens-trunks-black", "puma-supima-mens-trunks-dark-olive", "puma-supima-mens-trunks-team-royal", "puma-thermoshield-mens-long-sleeve-thermal-top-68802401", "puma-thermoshield-mens-long-sleeve-thermal-top-68802402", "puma-thermoshield-mens-thermal-pants-68841101", "puma-thermoshield-mens-thermal-pants-68841102", "puma-womens-long-sleeve-thermal-top-68841202", "puma-womens-long-sleeve-thermal-top-68841203", "puma-woven-boxer-inner-elastic-685257", "puma-woven-boxer-side-pocket-685241", "puma-woven-boxer-side-pocket-685242", "puma-woven-boxer-side-pocket-685243", "puma-woven-boxer-side-pocket-685244", "puma-woven-boxer-side-pocket-685245", "puma-woven-boxer-side-pocket-685246", "puma-woven-boxer-side-pocket-685247", "puma-woven-boxer-side-pocket-685248", "puma-woven-boxer-side-pocket-685249", "puma-woven-boxer-side-pocket-685250", "puma-woven-boxer-side-pocket-685253", "puma-woven-boxer-side-pocket-685254", "puma-woven-boxers-side-pocket-678651", "puma-woven-boxerside-pocket-685251", "puma-woven-boxerside-pocket-685252", "sport-quarter-socks-pack-of-1", "sport-quarter-socks-pack-of-2", "sport-quarter-socks-pack-of-3", "unisex-quarter-socks-pack-of-1", "womens-thermal-pants-68841301", "womens-thermal-pants-68841302", "womens-thermal-pants-68841303"] };
  var bagSet = {}; BAG.handles.forEach(function (h) { bagSet[h] = 1; });
  var rs = function (n) { return '₹' + Number(n).toLocaleString('en-IN'); };
  function bagCss() {
    if (document.getElementById('so-bag-css')) return;
    var st = document.createElement('style'); st.id = 'so-bag-css';
    st.textContent = '.so-card-bag{margin-top:4px;font-size:11px;font-weight:700;letter-spacing:.02em;color:#111}' +
      '.so-card-bag span{display:inline-block;border:1px solid #111;padding:1px 6px;border-radius:2px;margin-right:4px;font-size:10px}' +
      '.so-bagoffer{margin:12px 0 4px;border:1px solid #111;border-radius:4px;padding:12px 14px;background:#fafafa}' +
      '.so-bagoffer-h{font-weight:800;font-size:13px;letter-spacing:.04em;text-transform:uppercase;margin-bottom:8px}' +
      '.so-bagoffer-t{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;margin-bottom:8px}' +
      '.so-bagoffer-t div{background:#fff;border:1px solid #ddd;border-radius:3px;text-align:center;padding:6px 2px;font-size:11px;color:#555}' +
      '.so-bagoffer-t b{display:block;font-size:15px;color:#111}' +
      '.so-bagoffer-n{font-size:12px;color:#444;line-height:1.45}.so-bagoffer-n a{color:#111;font-weight:700;text-decoration:underline}';
    document.head.appendChild(st);
  }
  function bagCard(card) {
    var a = card.querySelector('a[href*="/products/"]');
    var box = card.querySelector('.so-card-price-box');
    if (!a || !box || card.querySelector('.so-card-bag')) return;
    var h = decodeURIComponent((a.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0]);
    if (!bagSet[h]) return;
    var d = document.createElement('div'); d.className = 'so-card-bag';
    d.innerHTML = '<span>BAG OFFER</span>Up to 50% off in bag';
    box.parentNode.insertBefore(d, box.nextSibling);
  }
  function bagPDP() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m || !bagSet[decodeURIComponent(m[1])] || document.querySelector('.so-bagoffer')) return;
    var at = document.querySelector('.so-saveline') || document.querySelector('.so-pricerow');
    if (!at) return;
    var d = document.createElement('div'); d.className = 'so-bagoffer';
    d.innerHTML = '<div class="so-bagoffer-h">Bag offer on this style</div><div class="so-bagoffer-t">' +
      BAG.tiers.map(function (t) { return '<div>Shop ' + rs(t[0]) + '<b>' + t[1] + '% off</b></div>'; }).join('') +
      '</div><div class="so-bagoffer-n">Add this and other bag-offer styles. The discount is applied automatically in your bag and at checkout, no code needed. <a href="/collections/offers#so-offers-guide">How it works</a></div>';
    at.parentNode.insertBefore(d, at.nextSibling);
  }
  // Top ticker (baked into every page): lead with the bag offer, link to the Offers guide.
  var ANN = { 'Up to 60% off size S': 'Bag offer: 20–50% off from ₹2,999', 'All styles · All brands': 'Up to 60% off size S', 'Shop size S →': 'See all offers →' };
  function bagAnn() {
    var a = document.querySelector('a.so-ann');
    if (!a || a.getAttribute('data-so-bag')) return;
    a.setAttribute('data-so-bag', '1');
    a.setAttribute('href', '/collections/offers#so-offers-guide');
    a.setAttribute('aria-label', 'Bag offer: 20 to 50% off from ₹2,999, applied automatically. Up to 60% off size S. See all offers');
    [].forEach.call(a.querySelectorAll('.so-ann-item'), function (it) { var t = it.textContent.trim(); if (ANN[t]) it.textContent = ANN[t]; });
  }
  function bagAll() {
    if (!BAG.live) return; // paused 13 Oct evening, set live:true to restore
    try { bagAnn(); } catch (e) {}
    bagCss();
    [].forEach.call(document.querySelectorAll('.t4s-product'), function (c) { try { bagCard(c); } catch (e) {} });
    try { bagPDP(); } catch (e) {}
  }

  function oosCss() {
    if (document.getElementById('so-oos-css')) return;
    var st = document.createElement('style'); st.id = 'so-oos-css';
    st.textContent = '.t4s-product.so-oos{display:none!important}';
    document.head.appendChild(st);
  }
  // re-run the collection grid so its count + 24-per-page skip the hidden cards
  function oosRegrid() {
    if (!paintCard.changed) return;
    paintCard.changed = false;
    var sort = document.getElementById('so-sort-select');
    if (sort && document.querySelector('[data-so-grid]')) sort.dispatchEvent(new Event('change'));
  }

  function run() {
    oosCss();
    bagAll();
    load().then(function (map) {
      [].forEach.call(document.querySelectorAll('.t4s-product'), function (c) { try { paintCard(c, map); } catch (e) {} });
      oosRegrid();
      try { paintPDP(map); } catch (e) {}
      if (!run.obs && window.MutationObserver) {
        var t;
        run.obs = new MutationObserver(function () {
          clearTimeout(t);
          t = setTimeout(function () {
            [].forEach.call(document.querySelectorAll('.t4s-product'), function (c) { try { paintCard(c, map); } catch (e) {} });
            bagAll();
          }, 150);
        });
        run.obs.observe(document.body, { childList: true, subtree: true });
      }
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
